import { render, staticRenderFns } from "./Short_form_tea_JumpAttribute.vue?vue&type=template&id=df4cc52a&scoped=true&"
import script from "./Short_form_tea_JumpAttribute.vue?vue&type=script&lang=js&"
export * from "./Short_form_tea_JumpAttribute.vue?vue&type=script&lang=js&"
import style0 from "./Short_form_tea_JumpAttribute.vue?vue&type=style&index=0&id=df4cc52a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4cc52a",
  null
  
)

export default component.exports